import { render, staticRenderFns } from "./profits.vue?vue&type=template&id=79b467bb&scoped=true&"
import script from "./profits.vue?vue&type=script&lang=js&"
export * from "./profits.vue?vue&type=script&lang=js&"
import style0 from "./profits.vue?vue&type=style&index=0&id=79b467bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b467bb",
  null
  
)

export default component.exports